module.exports = __webpack_public_path__ + "assets/1-Denver-Tech-Sales-Opportunities.0351a93e.png";